import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IStaticAdv } from '@/api/routes/forms/types';

import { fetchInstallSidesAdv, fetchStaticAdv } from './actionCreators';

interface InitialState {
  staticAdv: IStaticAdv[],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  staticAdv: [],
  isLoading: false,
  error: '',
};

export const staticAdvFormSlice = createSlice({
  name: 'staticAdvForm',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchStaticAdv.fulfilled.type]: (state, action: PayloadAction<IStaticAdv[]>) => {
      state.isLoading = false;
      state.error = '';
      state.staticAdv = action.payload;
    },
    [fetchStaticAdv.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchStaticAdv.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    [fetchInstallSidesAdv.fulfilled.type]: (state, action: PayloadAction<IStaticAdv[]>) => {
      state.isLoading = false;
      state.error = '';
      state.staticAdv = action.payload;
    },
    [fetchInstallSidesAdv.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchInstallSidesAdv.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default staticAdvFormSlice.reducer;
